export const NUMBER_FORMAT = {
    FORMAT_1: 1,
    FORMAT_2: 2,
    FORMAT_3: 3,
    FORMAT_4: 4,
    FORMAT_5: 5,
    FORMAT_6: 6
}